export default __webpack_public_path__ + "static/media/blog2.a5098a86.png";